export default __webpack_public_path__ + "static/media/fastingdrink-wide@2x.f16b21de.jpg";